/* ============================================================
   arthene — Schätzung, seitenspezifische Ergänzungen
   Portiert aus prototypes/assets/schaetzung.js.

   Die allgemeinen Formularteile (Prüfung, Zeichenzähler, Entwurf,
   Schritt-Navigation) kommen aus arthene-formular.js. Hier steht nur,
   was es sonst nirgends gibt: Foto-Upload, Preisformat, Vorgangsnummer
   und der Versand an den externen Endpoint.
   ============================================================ */
(function () {
  'use strict';

  var root = document.getElementById('formular');
  var form = document.getElementById('schaetzungForm');
  if (!root || !form) return;

  var $ = function (id) { return document.getElementById(id); };

  /* Diese Datei rendert kein Liquid und kennt die Sprache deshalb nicht. Die
     Section hängt die Texte als data-text-… an #formular; hier werden sie
     abgelesen. Fehlt ein Attribut, bleibt der deutsche Rückfall stehen und die
     Seite läuft einsprachig weiter. Gleiches Muster wie am Schnellkauf. */
  function meldungstext(name, rueckfall) {
    return root.getAttribute('data-text-' + name) || rueckfall;
  }
  var isEndpoint = form.hasAttribute('data-endpoint');
  var contactEmail = root.getAttribute('data-contact-email') || '';
  var maxFiles = parseInt(root.getAttribute('data-max-files'), 10) || 8;
  var maxFileMB = parseInt(root.getAttribute('data-max-file-mb'), 10) || 10;
  var maxTotalMB = maxFileMB * 4;
  var ACCEPT = ['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif'];

  /* ---- Vorgangsnummer: hilft, später zugesandte Fotos zuzuordnen ---- */
  var d = new Date();
  var stamp = String(d.getFullYear()).slice(2) +
              String(d.getMonth() + 1).padStart(2, '0') +
              String(d.getDate()).padStart(2, '0');
  var reference = 'AS-' + stamp + '-' + Math.random().toString(36).slice(2, 6).toUpperCase();

  var refInput = document.createElement('input');
  refInput.type = 'hidden';
  refInput.name = isEndpoint ? 'vorgang' : 'contact[Vorgang]';
  refInput.value = reference;
  form.appendChild(refInput);

  var refOut = $('doneRef');
  if (refOut) refOut.textContent = reference;

  /* Der Betreff wird an zwei Stellen gebraucht — im Mail-Knopf der
     Rückfallebene und in der Bestätigung nach dem Versand. */
  var mailBetreff = meldungstext('mail-betreff', 'Fotos zur Schätzung {{ vorgang }}')
    .replace('{{ vorgang }}', reference);

  /* ---- Mail-Link für die Fotos (nur in der Shopify-Rückfallebene) ---- */
  var mailLink = $('mailNoteLink');
  if (mailLink && contactEmail) {
    /* Anrede, Satz und Gruß sind drei Schlüssel, weil Zeilenumbrüche in einem
       HTML-Attribut nichts verloren haben — zusammengesetzt wird hier. */
    var mailText = meldungstext('mail-anrede', 'Guten Tag,') + '\n\n' +
      meldungstext('mail-text', 'anbei die Fotos zu meiner Schätzungsanfrage {{ vorgang }}.')
        .replace('{{ vorgang }}', reference) + '\n\n' +
      meldungstext('mail-gruss', 'Mit freundlichen Grüßen') + '\n';
    mailLink.href = 'mailto:' + contactEmail +
      '?subject=' + encodeURIComponent(mailBetreff) +
      '&body=' + encodeURIComponent(mailText);
  }

  function setError(el, msg) {
    var wrap = el && el.closest('[data-field]');
    if (!wrap) return;
    var out = wrap.querySelector('[data-err]');
    if (msg) wrap.classList.add('is-invalid'); else wrap.classList.remove('is-invalid');
    if (out) out.textContent = msg || '';
  }

  /* ========================================================
     Foto-Upload: Dropzone, Vorschau, Entfernen
     ======================================================== */
  var fileInput = $('fotos');
  var dropzone = $('dropzone');
  var thumbs = $('thumbs');
  var dropBar = $('dropBar');
  var files = [];

  var fmtSize = function (b) {
    return b < 1048576
      ? Math.round(b / 1024) + ' KB'
      : (b / 1048576).toFixed(1).replace('.', ',') + ' MB';
  };

  function syncInput() {
    var dt = new DataTransfer();
    files.forEach(function (f) { dt.items.add(f); });
    fileInput.files = dt.files;
  }

  function renderFiles() {
    thumbs.querySelectorAll('img').forEach(function (img) { URL.revokeObjectURL(img.src); });
    thumbs.innerHTML = '';
    files.forEach(function (f, i) {
      var li = document.createElement('li');
      li.className = 'thumb';
      var img = document.createElement('img');
      img.src = URL.createObjectURL(f);
      img.alt = meldungstext('vorschau', 'Vorschau: {{ name }}').replace('{{ name }}', f.name);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'thumb__x';
      btn.setAttribute('aria-label', meldungstext('entfernen', '{{ name }} entfernen').replace('{{ name }}', f.name));
      btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
      btn.addEventListener('click', function () { files.splice(i, 1); syncInput(); renderFiles(); });
      var meta = document.createElement('p');
      meta.className = 'thumb__meta';
      meta.textContent = fmtSize(f.size);
      li.appendChild(img); li.appendChild(btn); li.appendChild(meta);
      thumbs.appendChild(li);
    });
    var total = files.reduce(function (s, f) { return s + f.size; }, 0);
    dropBar.hidden = files.length === 0;
    $('dropCount').textContent = meldungstext('anzahl', '{{ anzahl }} von {{ max }} Bildern · {{ groesse }}')
      .replace('{{ anzahl }}', files.length)
      .replace('{{ max }}', maxFiles)
      .replace('{{ groesse }}', fmtSize(total));
  }

  function addFiles(list) {
    var rejected = [];
    Array.prototype.slice.call(list).forEach(function (f) {
      /* Ein Schlüssel je vollständiger Meldung, mit dem Dateinamen als
         Platzhalter — der steht nicht in jeder Sprache am Satzanfang. */
      if (files.length >= maxFiles) {
        rejected.push(meldungstext('zu-viele', '{{ name }} — Höchstzahl erreicht').replace('{{ name }}', f.name));
        return;
      }
      if (ACCEPT.indexOf(f.type) === -1) {
        rejected.push(meldungstext('format', '{{ name }} — Format nicht unterstützt').replace('{{ name }}', f.name));
        return;
      }
      if (f.size > maxFileMB * 1048576) {
        rejected.push(meldungstext('zu-gross', '{{ name }} — größer als {{ max }} MB')
          .replace('{{ name }}', f.name).replace('{{ max }}', maxFileMB));
        return;
      }
      if (files.some(function (x) { return x.name === f.name && x.size === f.size; })) return;
      files.push(f);
    });
    var total = function () { return files.reduce(function (s, f) { return s + f.size; }, 0); };
    while (files.length && total() > maxTotalMB * 1048576) {
      rejected.push(meldungstext('gesamt', '{{ name }} — Gesamtgröße über {{ max }} MB')
        .replace('{{ name }}', files.pop().name).replace('{{ max }}', maxTotalMB));
    }
    syncInput();
    renderFiles();
    setError(fileInput, rejected.length
      ? meldungstext('nicht-uebernommen', 'Nicht übernommen: {{ liste }}.').replace('{{ liste }}', rejected.join('; '))
      : '');
  }

  if (fileInput && dropzone) {
    fileInput.addEventListener('change', function () {
      var picked = Array.prototype.slice.call(fileInput.files);
      files = []; syncInput(); addFiles(picked);
    });
    ['dragenter', 'dragover'].forEach(function (ev) {
      dropzone.addEventListener(ev, function (e) { e.preventDefault(); dropzone.classList.add('is-over'); });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      dropzone.addEventListener(ev, function (e) { e.preventDefault(); dropzone.classList.remove('is-over'); });
    });
    dropzone.addEventListener('drop', function (e) {
      if (e.dataTransfer && e.dataTransfer.files.length) addFiles(e.dataTransfer.files);
    });
    var clearFiles = $('clearFiles');
    if (clearFiles) {
      clearFiles.addEventListener('click', function () {
        files = []; syncInput(); renderFiles(); setError(fileInput, '');
      });
    }
  }

  /* ========================================================
     Kleine Feldhelfer
     ======================================================== */
  /* „Sonstiges" blendet das Freitextfeld ein */
  var farbe = $('farbe');
  var farbeAndersWrap = $('farbeAndersWrap');
  if (farbe && farbeAndersWrap) {
    var syncFarbe = function () { farbeAndersWrap.hidden = farbe.value !== 'Sonstiges'; };
    farbe.addEventListener('change', syncFarbe);
    syncFarbe();
  }

  /* Preis: nur Ziffern, beim Verlassen mit Tausenderpunkten */
  var preis = $('preis');
  if (preis) {
    preis.addEventListener('input', function () { preis.value = preis.value.replace(/[^\d]/g, ''); });
    preis.addEventListener('blur', function () {
      if (preis.value) preis.value = Number(preis.value).toLocaleString('de-DE');
    });
    preis.addEventListener('focus', function () { preis.value = preis.value.replace(/[^\d]/g, ''); });
  }

  var keinPreis = $('keinPreis');
  if (keinPreis && preis) {
    var syncPreis = function () {
      preis.disabled = keinPreis.checked;
      if (keinPreis.checked) { preis.value = ''; setError(preis, ''); }
    };
    keinPreis.addEventListener('change', syncPreis);
    syncPreis();
  }

  /* ========================================================
     Versand an den externen Endpoint (nur wenn eine URL gesetzt ist).
     In der Shopify-Rückfallebene passiert hier nichts — dort postet
     das Formular ganz normal an /contact.
     ======================================================== */
  if (!isEndpoint) return;

  var summary = $('errorSummary');
  var summaryList = $('errorSummaryList');
  var submitBtn = $('submitBtn');
  var submitLabel = $('submitLabel');
  /* Die Beschriftung des Knopfes steht schon übersetzt im Markup. Sie wird
     gemerkt statt noch einmal übersetzt, damit sie nach dem Versand exakt so
     zurückkommt, wie sie war. */
  var submitLabelText = submitLabel ? submitLabel.textContent : '';

  function showDone() {
    root.classList.add('is-done');
    var done = $('done');
    done.classList.add('is-visible');
    var photos = $('donePhotos');
    if (photos && contactEmail && files.length === 0) {
      var anker = '<a href="mailto:' + contactEmail + '?subject=' +
        encodeURIComponent(mailBetreff) + '">' + contactEmail + '</a>';
      photos.hidden = false;
      photos.innerHTML = meldungstext(
        'ohne-fotos',
        'Sie haben keine Fotos angehängt. Sie können sie jederzeit an {{ mail }} nachreichen — mit der Vorgangsnummer im Betreff.'
      ).replace('{{ mail }}', anker);
    }
    done.focus();
    done.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  form.addEventListener('submit', function (e) {
    /* arthene-formular.js hat schon geprüft und bei Fehlern abgebrochen.
       Kommen wir hier an und das Standardverhalten läuft noch, ist alles gut. */
    if (e.defaultPrevented) return;
    e.preventDefault();

    submitBtn.disabled = true;
    submitBtn.setAttribute('aria-busy', 'true');
    submitLabel.textContent = meldungstext('wird-gesendet', 'Wird gesendet …');

    fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'application/json' }
    }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      showDone();
    }).catch(function () {
      /* Zwei vollständige Sätze statt eines mit angehängtem Nachsatz: der
         Hinweis auf die Mail-Adresse steht nicht in jeder Sprache am Ende. */
      var meldung = contactEmail
        ? meldungstext(
            'versand-fehler-mail',
            'Die Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es erneut oder schreiben Sie uns an {{ mail }}.'
          ).replace('{{ mail }}', '<a href="mailto:' + contactEmail + '">' + contactEmail + '</a>')
        : meldungstext('versand-fehler', 'Die Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es erneut.');
      summaryList.innerHTML = '<li>' + meldung + '</li>';
      summary.classList.add('is-visible');
      summary.focus();
    }).then(function () {
      submitBtn.disabled = false;
      submitBtn.removeAttribute('aria-busy');
      submitLabel.textContent = submitLabelText;
    });
  });
})();
